import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import ReactMarkdown from 'react-markdown';

import styles from './Markdown.css';

const Markdown = ({ file, styled }) => {
  const cx = classnames.bind(styles);
  const classes = cx({ markdown: styled });

  return <ReactMarkdown className={classnames('main-content', classes)} source={file} />;
};

Markdown.propTypes = {
  file: PropTypes.string.isRequired,
  styled: PropTypes.bool,
};

Markdown.defaultProps = {
  styled: true,
};

Markdown.displayName = 'Markdown';

export default Markdown;




// WEBPACK FOOTER //
// ./src/components/Markdown/Markdown.js